import { Box, Button, Card, Stack, Typography } from "@mui/material";

import { TUTRED_CLIENT_HOSTNAME } from "@/constants";

const LandingPage = () => {
  const tutredUrl = TUTRED_CLIENT_HOSTNAME || "https://www.tutred.com";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: 4,
      }}
    >
      <Card variant="elevation" elevation={6} sx={{ p: 6 }}>
        <Stack alignItems="center" textAlign="center">
          <Typography
            component="div"
            sx={{
 fontSize: "44px",
lineHeight: 1 
}}
          >
            🗺️
          </Typography>

          <Typography
            variant="h2Serif"
            component="h1"
            sx={{ letterSpacing: "-0.02em" }}
          >
            You took a wrong turn
          </Typography>

          <Typography variant="text14R" sx={{
 mt: 2,
mb:4, 
}}>
            There's nothing here — lesson links can be found in your email. Head back to Tutred to find your lesson.
          </Typography>

          <Button
            variant="contained"
            component="a"
            href={tutredUrl}
          >
            Back to Tutred
          </Button>
        </Stack>
      </Card>
    </Box>
  );
};

export default LandingPage;
